import {act343PrizeMap, inmsg343DefFilters} from "./InmsgTable";
import {schemas} from "../config";
import React from "react";
import QrFromImage from "../342/actions/QrFromImage";
import SetWinners from "./actions/SetWinners";
import {LANG} from "../components/CONSTANTS";
import {certificates343DefFilters} from "./CertificatesTable";
import SendCertificates from "./actions/SendCertificates";


export const act343Functions = {
    inmsg343DefFilters: () => inmsg343DefFilters(),
    certificates343DefFilters: () => certificates343DefFilters(),
    inmsg343SetWinners: () => <SetWinners/>,
    certificates343SendCertificate: () => <SendCertificates/>,
    inmsg343AllPrizesFields: (value: string, schema: any, forHeader = false, record = null) => {
        return value !== 'null' ? value.split(",").map(id => act343PrizeMap.values[id].lang[LANG]).join(", ") : ''
    }
    ,
    uniqueId343Qr: (value, schema, forHeader = false, record = null) => record ?
        <QrFromImage value={value} id={record['id']}
                     imageUrl={schemas['act343'].backend + "/proxy.php?url=" + encodeURIComponent(record["check_photo"])}/> : value,
} as { [p: string]: (...args: any[]) => any }
